document.addEventListener('DOMContentLoaded', function () {
  initEmbroidery();
});

function initEmbroidery() {
  var form = document.querySelector('form[action="/cart/add"]');
  var embroideryWrapper = document.querySelector('form .embroidery');

  if (window.embroidery && embroideryWrapper) {
    var embroideryFormContainer = document.createElement('div');
    var dropdown = buildEmbroideryDropdown();
    var dropdownLabel = buildStaticElement('<label for="{{dropdownId}}">{{dropdownCaption}}</label>', {
      "{{dropdownId}}": dropdown.id,
      "{{dropdownCaption}}": window.embroidery.dropText
    });
    var options = buildEmbroideryOptions();

    for (var option of options) {
      dropdown.appendChild(option);
    }

    // Add handler
    dropdown.addEventListener('change', embroideryTypeChange);

    embroideryWrapper.appendChild(dropdownLabel);
    embroideryWrapper.appendChild(dropdown);

    embroideryFormContainer.classList.add('embroidery-form-wrapper');
    embroideryWrapper.appendChild(embroideryFormContainer);

    // Add a hidden field for the timestamp token
    var timestampElement = document.createElement('input');

    timestampElement.name = 'properties[_addedToken]';
    timestampElement.type = 'hidden';
    timestampElement.value = new Date().valueOf();
    
    embroideryWrapper.appendChild(timestampElement);

    // Add form submit override
    form.addEventListener('submit', formSubmitOverride);
  } else {
    console.error('No embroidery wrapper was found or the window.embroidery object does not exist!');
  }
}

async function formSubmitOverride(e) {
  var form = e.currentTarget;
  var formData = new FormData(form);
  var itemsToAdd = {
    items: []
  };

  e.preventDefault();

  try {
    // Get the entries in the form object for the product
    var product = {};

    for (var option of formData.entries()) {
      if (option[0].indexOf('properties') == 0) {
        var propertyName = option[0].replace(/properties\[/gi, '').replace(/\]/gi, '');

        if (!product.properties) {
          product.properties = {};
        }

        product.properties[propertyName] = option[1];
      } else {
        product[option[0]] = option[1];
      }
    }

    itemsToAdd.items.push(product);

    // Check if there is an embroidery option selected
    var embroideryType = product.properties['Embroidery Type'] || 'None';
    var addedToken = product.properties['_addedToken'] || new Date().valueOf();

    if (embroideryType != 'None') {
      var variantId = null;

      switch (embroideryType) {
        case 'Initials':
          variantId = embroidery.variants.initials.id;
          break;
        case 'Full Name':
          variantId = embroidery.variants.fullName.id;
          break;
        case 'Novelty Initials':
          variantId = embroidery.variants.monogram.id;
          break;
        case 'Cece DuPraz Novelty Crayon':
          variantId = embroidery.variants.specialMonogram.id;
          break;
        case 'Oversize Initials':
          variantId = embroidery.variants.oversizeInitials.id;
          break;
        case 'Oversize Full Name':
          variantId = embroidery.variants.oversizeFullName.id;
          break;
      }

      if (variantId) {
        itemsToAdd.items.push({
          id: variantId,
          properties: {
            _addedToken: addedToken
          }
        });
      } else {
        console.error('No matching variant found!');
      }
    }

    await sendRequest('/cart/add.js', itemsToAdd);

    window.location.href = '/cart';
  } catch (err) {
    console.error('Error:', err);
  }
}

function sendRequest(url, data) {
  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();

    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        resolve(JSON.parse(request.responseText));
      } else {
        reject(request.responseText);
      }
    }

    request.open('POST', url, true);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
  });
}

function buildEmbroideryDropdown() {
  var template = `<select id="embroidery-type" name="properties[Embroidery Type]"></select>`;
  var element = document.createElement('div');

  element.innerHTML = template;

  return element.querySelector('select');
}

function buildEmbroideryOptions() {
  var options = [];
  var optionTemplate = '<option value="{{value}}">{{caption}}</option>';
  var fullNameVariant = embroidery.variants.fullName;
  var initialsVariant = embroidery.variants.initials;
  var monogramVariant = embroidery.variants.monogram;
  var specialtyMonogramVariant = embroidery.variants.specialMonogram;
  var oversizeInitialVariant = embroidery.variants.oversizeInitials;
  var oversizeFullNameVariant = embroidery.variants.oversizeFullName;
  
  // Add the 'No' option
  options.push(buildStaticElement(optionTemplate, {
    "{{value}}": "None",
    "{{caption}}": "No embroidery"
  }));

  if (embroidery.initials) {
    options.push(buildStaticElement(optionTemplate, {
      "{{value}}": "Initials",
      "{{caption}}": `Initials (+$${initialsVariant.price.toFixed(2)})`
    }));
  }

  if (embroidery.fullName) {
    options.push(buildStaticElement(optionTemplate, {
      "{{value}}": "Full Name",
      "{{caption}}": `Full Name (+$${fullNameVariant.price.toFixed(2)})`
    }));
  }

  if (embroidery.monogram) {
    options.push(buildStaticElement(optionTemplate, {
      "{{value}}": "Novelty Initials",
      "{{caption}}": `Novelty Initials (+$${monogramVariant.price.toFixed(2)})`
    }));
  }

  if (embroidery.specialMonogram) {
    options.push(buildStaticElement(optionTemplate, {
      "{{value}}": "Cece DuPraz Novelty Crayon",
      "{{caption}}": `Cece DuPraz Novelty Crayon (+$${specialtyMonogramVariant.price.toFixed(2)})`
    }));
  }

  if (embroidery.oversizeInitial) {
    options.push(buildStaticElement(optionTemplate, {
      "{{value}}": "Oversize Initials",
      "{{caption}}": `Oversize Initials (+$${oversizeInitialVariant.price.toFixed(2)})`
    }));
  }

  if (embroidery.oversizeFullName) {
    options.push(buildStaticElement(optionTemplate, {
      "{{value}}": "Oversize Full Name",
      "{{caption}}": `Oversize Full Name (+$${oversizeFullNameVariant.price.toFixed(2)})`
    }));
  }

  return options;
}

function buildStaticElement(template, placeholders) {
  var element = document.createElement('div');
  var placeholderKeys = Object.keys(placeholders);

  for (var placeholder of placeholderKeys) {
    template = template.replace(placeholder, placeholders[placeholder]);
  }

  element.innerHTML = template;

  return element.querySelector('*');
}

function embroideryTypeChange(event) {
  var element = event.currentTarget;
  var wrapper = element.closest('.embroidery');
  var formWrapper = wrapper.querySelector('.embroidery-form-wrapper');
  var value = element.value;

  switch (value) {
    case 'Full Name':
      formWrapper.innerHTML = buildFullNameForm(embroidery.forms.fullName);
      break;
    case 'Initials':
      formWrapper.innerHTML = buildInitialsForm(embroidery.forms.initials);
      break;
    case 'Novelty Initials':
      formWrapper.innerHTML = buildMonogramForm(embroidery.forms.monogram);
      break;
    case 'Cece DuPraz Novelty Crayon':
      formWrapper.innerHTML = buildSpecialForm(embroidery.forms.specialMonogram);
      break;
    case 'Oversize Initials':
      formWrapper.innerHTML = buildOversizeIntialsForm( embroidery.forms.oversizeInitials );
      break;
    case 'Oversize Full Name':
      formWrapper.innerHTML = buildOversizeFullName( embroidery.forms.oversizeFullName );
      break;
    default:
      formWrapper.innerHTML = '';
      break;
  }

  // Set initial values
  var form = formWrapper.querySelector('.embroidery-form');

  if (form) {
    var inputFields = form.querySelectorAll('.input_field');

    for (var input of inputFields) {
      var radioButton = input.querySelector('input[type="radio"]');
      input.addEventListener('change', valueChange);

      if (radioButton) {
        var wrapper = radioButton.closest('div');
        var label = wrapper.querySelector('span.selected-value');

        radioButton.checked = true;
        label.innerText = radioButton.value;

        console.log(radioButton.dataset)
        if (radioButton.getAttribute('name') == 'properties[Embroidery style]') {
        if (radioButton.dataset.character_limit == 'true') {
          if (document.querySelector('.multiple_output') && document.querySelector('.single_output')) {
            document.querySelector('.multiple_output').style.display='none';
            document.querySelector('.single_output').style.display='block';
            document.querySelectorAll('.multiple_output input[type="text"]').forEach((input) => {
              input.required = false;
            });
            document.querySelectorAll('.single_output input[type="text"]').forEach((input) => {
              input.required = true;
              if (radioButton.dataset.character_max && radioButton.dataset.character_max != '0') {
                input.setAttribute('maxlength', radioButton.dataset.character_max);
              }
            });

          }
        } else {
          if (document.querySelector('.multiple_output') && document.querySelector('.single_output')) {
            document.querySelector('.multiple_output').style.display='block';
            document.querySelector('.single_output').style.display='none';
            document.querySelectorAll('.multiple_output input[type="text"]').forEach((input) => {
              input.required=true;
            });
            document.querySelectorAll('.single_output input[type="text"]').forEach((input) => {
              input.required=false;
            });
          }
        }
      }
      }

      
    }
  }
}

function valueChange(e) {
  var element = e.target;

  console.log("CLICKING ON SOMETHING - ", element);

  if (element.type && element.type == 'radio') {
    var wrapper = element.closest('div');
    var label = wrapper.querySelector('span.selected-value');

    label.innerText = element.value;
    if (element.getAttribute('name') == 'properties[Embroidery style]') {
    if (element.dataset.character_limit == 'true') {
      if (document.querySelector('.multiple_output') && document.querySelector('.single_output')) {
            document.querySelector('.multiple_output').style.display='none';
            document.querySelector('.single_output').style.display='block';
            document.querySelectorAll('.multiple_output input[type="text"]').forEach((input) => {
              input.required = false;
            });
            document.querySelectorAll('.single_output input[type="text"]').forEach((input) => {
              input.required = true;
              if (element.dataset.character_max && element.dataset.character_max != '0') {
                input.setAttribute('maxlength', element.dataset.character_max);
              }
            });
      }
    } else {
      if (document.querySelector('.multiple_output') && document.querySelector('.single_output')) {
          document.querySelector('.multiple_output').style.display='block';
            document.querySelector('.single_output').style.display='none';
            document.querySelectorAll('.multiple_output input[type="text"]').forEach((input) => {
              input.required=true;
            });
            document.querySelectorAll('.single_output input[type="text"]').forEach((input) => {
              input.required=false;
            });;
      }
    }
  }

  }
}

function buildFullNameForm(template) {
  var output = template;
  var matchingFonts = embroidery.fonts.filter(function (font) {
    return font.allowFullName;
  });
  var matchingColors = embroidery.colors.filter(function (color) {
    return color.allow_full_name;
  })
  var fontSelectors = '';
  var colorSelectors = '';

  for (var font of matchingFonts) {
    fontSelectors += buildFontBlock(font);
  }

  for (var color of matchingColors) {
    colorSelectors += buildColorBlock(color);
  }

  output = output.replace(/\[\[fonts\]\]/gi, fontSelectors);
  output = output.replace(/\[\[colors\]\]/gi, colorSelectors);

  return output;
}

function buildInitialsForm(template) {
  var output = template;
  var matchingFonts = embroidery.fonts.filter(function (font) {
    return font.allowInitials;
  });
  var matchingColors = embroidery.colors.filter(function (color) {
    return color.allow_initials;
  })
  var fontSelectors = '';
  var colorSelectors = '';

  for (var font of matchingFonts) {
    fontSelectors += buildFontBlock(font);
  }

  for (var color of matchingColors) {
    colorSelectors += buildColorBlock(color);
  }

  output = output.replace(/\[\[fonts\]\]/gi, fontSelectors);
  output = output.replace(/\[\[colors\]\]/gi, colorSelectors);

  return output;
}

function buildMonogramForm(template) {
  var output = template;
  var matchingFonts = embroidery.fonts.filter(function (font) {
    return font.allowMonogram;
  });
  var matchingColors = embroidery.colors.filter(function (color) {
    return color.allow_monogram;
  })
  var fontSelectors = '';
  var colorSelectors = '';

  for (var font of matchingFonts) {
    fontSelectors += buildFontBlock(font);
  }

  for (var color of matchingColors) {
    colorSelectors += buildColorBlock(color);
  }

  output = output.replace(/\[\[fonts\]\]/gi, fontSelectors);
  output = output.replace(/\[\[colors\]\]/gi, colorSelectors);

  return output;
}

function buildSpecialForm(template) {
  var output = template;
  var matchingFonts = embroidery.fonts.filter(function (font) {
    return font.allowSpecialMonogram;
  });
  var matchingColors = embroidery.colors.filter(function (color) {
    return color.allow_special_monogram;
  })
  var fontSelectors = '';
  var colorSelectors = '';

  for (var font of matchingFonts) {
    fontSelectors += buildFontBlock(font);
  }

  for (var color of matchingColors) {
    colorSelectors += buildColorBlock(color);
  }

  output = output.replace(/\[\[fonts\]\]/gi, fontSelectors);
  output = output.replace(/\[\[colors\]\]/gi, colorSelectors);

  return output;
}

function buildOversizeIntialsForm( template ) {
  var output = template;
  var matchingFonts = embroidery.fonts.filter(function (font) {
    return font.allowOversizeIntials;
  });
  var matchingColors = embroidery.colors.filter(function (color) {
    return color.allow_oversize_initials;
  })
  var fontSelectors = '';
  var colorSelectors = '';

  for (var font of matchingFonts) {
    fontSelectors += buildFontBlock(font);
  }

  for (var color of matchingColors) {
    colorSelectors += buildColorBlock(color);
  }

  output = output.replace(/\[\[fonts\]\]/gi, fontSelectors);
  output = output.replace(/\[\[colors\]\]/gi, colorSelectors);

  return output;
}

function buildOversizeFullName( template ) {
  var output = template;
  var matchingFonts = embroidery.fonts.filter(function (font) {
    return font.allowOversizeFullName;
  });
  var matchingColors = embroidery.colors.filter(function (color) {
    return color.allow_oversize_full_name;
  })
  var fontSelectors = '';
  var colorSelectors = '';

  for (var font of matchingFonts) {
    fontSelectors += buildFontBlock(font);
  }

  for (var color of matchingColors) {
    colorSelectors += buildColorBlock(color);
  }

  output = output.replace(/\[\[fonts\]\]/gi, fontSelectors);
  output = output.replace(/\[\[colors\]\]/gi, colorSelectors);

  return output;
}

function handleize(str) {
  return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};

function buildFontBlock(font) {
  var handle = handleize(font.title);
  var output = `
                <li>
                  <input type="radio" name="properties[Embroidery style]" id="font-${handle}" value="${font.title}" data-character_limit="${font.characterLimit}" data-character_max="${font.monogram_length}">
                  <label title="${font.title}" aria-label="${font.title}" for="font-${handle}">
                    <img src="${font.image}" />
                  </label>
                </li>`;

  return output;
}

function buildColorBlock(color) {
  var handle = handleize(color.title);
  var output = `
                <li>
                  <input type="radio" name="properties[Embroidery color]" id="color-${handle}" value="${color.title}">
                  <label class="color" title="${color.title}" aria-label="${color.title}" for="color-${handle}" style="background-color: ${color.color_code}"></label>
                </li>`;

  return output;
}